/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookRegistrationDto } from '../../models/book-registration-dto';

export interface BookPinPinGet$Params {
  pin: string;
}

export function bookPinPinGet(http: HttpClient, rootUrl: string, params: BookPinPinGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<BookRegistrationDto>> {
  const rb = new RequestBuilder(rootUrl, bookPinPinGet.PATH, 'get');
  if (params) {
    rb.path('pin', params.pin, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<BookRegistrationDto>;
    })
  );
}

bookPinPinGet.PATH = '/Book/Pin/{pin}';
